import { httpApi } from '@app/api/http.api';

// POST: Add a new retail price audit report
export const Contactus = (report: FormData): Promise<undefined> =>
  httpApi.post<undefined>('contactSupport', report).then(({ data }) => data);
